module.exports = __webpack_public_path__ + "img/floor2_top1.2edffc0e.png";